/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectGsvPerMonthPerVerticalResponse
 */
export interface ProjectGsvPerMonthPerVerticalResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectGsvPerMonthPerVerticalResponse
     */
    monthAndYear: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectGsvPerMonthPerVerticalResponse
     */
    vertical: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectGsvPerMonthPerVerticalResponse
     */
    gsv: number;
}

/**
 * Check if a given object implements the ProjectGsvPerMonthPerVerticalResponse interface.
 */
export function instanceOfProjectGsvPerMonthPerVerticalResponse(value: object): value is ProjectGsvPerMonthPerVerticalResponse {
    if (!('monthAndYear' in value) || value['monthAndYear'] === undefined) return false;
    if (!('vertical' in value) || value['vertical'] === undefined) return false;
    if (!('gsv' in value) || value['gsv'] === undefined) return false;
    return true;
}

export function ProjectGsvPerMonthPerVerticalResponseFromJSON(json: any): ProjectGsvPerMonthPerVerticalResponse {
    return ProjectGsvPerMonthPerVerticalResponseFromJSONTyped(json, false);
}

export function ProjectGsvPerMonthPerVerticalResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectGsvPerMonthPerVerticalResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'monthAndYear': json['monthAndYear'],
        'vertical': json['vertical'],
        'gsv': json['gsv'],
    };
}

export function ProjectGsvPerMonthPerVerticalResponseToJSON(value?: ProjectGsvPerMonthPerVerticalResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'monthAndYear': value['monthAndYear'],
        'vertical': value['vertical'],
        'gsv': value['gsv'],
    };
}

